/**
 * 运行时配置。**不写死域名** —— 同一份构建产物要能部署到不同环境。
 *
 * 从高到低：
 *   ?account= / ?gw=        调试用
 *   window.__LOBBY_CONFIG   部署时由 nginx 注入一小段 script
 *   Vite 的构建期变量        本地开发
 *   同源                    大厅和后端在同一个域后面时
 */
declare global {
  interface Window {
    __LOBBY_CONFIG?: { accountUrl?: string; gatewayUrl?: string; gameUrl?: string };
  }
}

function pick(qs: string, injected: string | undefined,
              env: string | undefined, fallback: string): string {
  const q = new URLSearchParams(location.search).get(qs);
  return (q || injected || env || fallback).replace(/\/*$/, '/');
}

const injected = typeof window === 'undefined' ? undefined : window.__LOBBY_CONFIG;

export const config = {
  accountUrl: pick('account', injected?.accountUrl,
                   import.meta.env.VITE_ACCOUNT_URL, 'http://localhost:8810/'),
  gatewayUrl: pick('gw', injected?.gatewayUrl,
                   import.meta.env.VITE_GATEWAY_URL, 'http://localhost:8800/'),
  // 游戏客户端（现在是 harness）。进游戏 = 带着 token 跳过去。
  gameUrl: pick('game', injected?.gameUrl,
                import.meta.env.VITE_GAME_URL, 'http://localhost:8788/'),
};
